var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUndo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon-undo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 19.875,
    viewBox: "0 0 25 19.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.546,15.941H5.281a1.04,1.04,0,1,1,0-2.079H16.546A5.951,5.951,0,0,0,22.53,7.97a5.951,5.951,0,0,0-5.985-5.891H1.056A1.056,1.056,0,0,1,0,1.04,1.056,1.056,0,0,1,1.056,0h15.49a8.044,8.044,0,0,1,8.1,7.97A8.044,8.044,0,0,1,16.546,15.941Z",
    transform: "translate(0.357 3.934)",
    fill: "#061133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.585,9.173a1.028,1.028,0,0,1-.735-.3L.3,5.319A1.046,1.046,0,0,1,.3,3.85L3.85.3A1.039,1.039,0,0,1,5.319,1.771L2.505,4.585,5.319,7.4a1.046,1.046,0,0,1,0,1.469A1.006,1.006,0,0,1,4.585,9.173Z",
    transform: "translate(0 0)",
    fill: "#061133"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndo);
export default __webpack_public_path__ + "static/media/Icon-undo.8e70a3b067cbc4c14c7cadca6d1667db.svg";
export { ForwardRef as ReactComponent };